import { Compass, Cpu, Calculator, FlaskConical, Rocket } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/i18n/LanguageContext';

const CONSULTING_IMAGE = "https://customer-assets.emergentagent.com/job_47fad209-51cc-4d0c-871e-c0ab0b53fdda/artifacts/ah7k8iaq_abstract-digital-business-chart-hologram-on-sky-ba-2026-01-11-08-47-44-utc.jpg";

export const ConsultingSection = () => {
  const { t } = useLanguage();

  const services = [
    { icon: Compass, text: t('consulting.service1') },
    { icon: Cpu, text: t('consulting.service2') },
    { icon: Calculator, text: t('consulting.service3') },
    { icon: FlaskConical, text: t('consulting.service4') },
    { icon: Rocket, text: t('consulting.service5') },
  ];

  return (
    <section id="consulting" className="py-20 md:py-32 bg-slate-50" data-testid="consulting-section">
      <div className="container-0g">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-sm overflow-hidden">
              <img
                src={CONSULTING_IMAGE}
                alt="Business optimization and cost control with IoT"
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
            </div>
            
            {/* ROI badge */}
            <div className="absolute bottom-6 right-6 bg-white/95 backdrop-blur-sm p-4 rounded-sm shadow-lg max-w-[200px]">
              <p className="text-xs text-slate-500 uppercase tracking-wider">{t('consulting.roiFocus')}</p>
              <p className="text-2xl font-bold text-teal-600">&lt; 3 {t('consulting.months')}</p>
              <p className="text-sm text-slate-600">{t('consulting.roiTarget')}</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <p className="section-label">{t('consulting.label')}</p>
            <h2 className="section-title mb-6">
              {t('consulting.title')}{' '}
              <span className="text-teal-600">{t('consulting.titleHighlight')}</span>
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              {t('consulting.subtitle')}
            </p>

            {/* Services list */}
            <div className="space-y-3 mb-8">
              {services.map((service, index) => {
                const Icon = service.icon;
                return (
                  <div 
                    key={index} 
                    className="flex items-center space-x-3"
                    data-testid={`consulting-service-${index}`}
                  >
                    <div className="w-8 h-8 rounded-sm bg-teal-600/10 flex items-center justify-center">
                      <Icon className="h-4 w-4 text-teal-600" />
                    </div>
                    <span className="text-slate-700 font-medium">{service.text}</span>
                  </div>
                );
              })}
            </div>

            <Button 
              className="btn-primary"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              data-testid="consulting-cta"
            >
              {t('consulting.cta')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
